<mad-data-table
  [filterMode]="'COLUMN_BASED'"
  [displayedColumns]="displayedColumns"
  [tableData]="tableData"
  [paginationEnabled]="paginationEnabled"
  [pageSizeOptions]="[5, 10, 15]"
  [defaultPageSize]="10"
>
</mad-data-table>
